module.exports = __webpack_public_path__ + "static/media/travel.203608ab.png";